import { styled } from '../theme';

const StyledForm = styled('form')`
    display: flex;
    flex-direction: column;
`;

const Form = ({ onSubmit, children }) => {
    return <StyledForm onSubmit={onSubmit}>{children}</StyledForm>;
};

export default Form;
